module.exports = __webpack_public_path__ + "static/media/btn-filter.e767ebfb.svg";